import React, { useState, useEffect } from "react";
import "./AddressModal.css";
import indianStates from "../Assets/all_states";

const AddressModal = ({ isOpen, onClose, onSave, initialData }) => {
    const [form, setForm] = useState({
        full_name: initialData?.name || "",
        phone: initialData?.phoneno || "",
        address_line1: "",
        address_line2: "",
        landmark: "",
        city: "",
        state: "",
        pincode: "",
        address_type: "HOME",
        is_default: false,
    });

    // useEffect(() => {
    //     if (initialData) setForm(initialData);
    // }, [initialData]);

    if (!isOpen) return null;

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setForm({ ...form, [name]: type === "checkbox" ? checked : value });
    };

    const handleSubmit = () => {
        if (
            !form.full_name ||
            !form.phone ||
            !form.address_line1 ||
            !form.city ||
            !form.state ||
            !form.pincode
        ) {
            alert("Please fill all required fields");
            return;
        }
        onSave(form);
    };

    return (
        <div className="address-overlay">
            <div className="address-modal">

                {/* Header */}
                <div className="address-header">
                    <h3>{initialData ? "Edit Address" : "Add New Address"}</h3>
                    <button className="close-btn" onClick={onClose}>×</button>
                </div>

                {/* Body */}
                <div className="address-body">
                    <label>
                        Full Name <span className="required">*</span>
                    </label>
                    <input name="full_name" type="text" value={form.full_name} onChange={handleChange} />

                    <label>
                        Mobile Number <span className="required">*</span>
                    </label>
                    <input name="phone" type="tel" maxLength="10" value={form.phone} onChange={handleChange} />

                    <label>
                        Address Line 1 <span className="required">*</span>
                    </label>
                    <input name="address_line1" type="text" value={form.address_line1} onChange={handleChange} />

                    <label>
                        Address Line 2
                    </label>
                    <input name="address_line2" type="text" value={form.address_line2} onChange={handleChange} />

                    <label>
                        Landmark
                    </label>
                    <input name="landmark" type="text" value={form.landmark} onChange={handleChange} />

                    <div className="row">
                        <div className="field">
                            <label>
                                City <span className="required">*</span>
                            </label>
                            <input
                                name="city"
                                type="text"
                                value={form.city}
                                onChange={handleChange}
                            />
                        </div>

                        <div className="field">
                            <label>
                                State <span className="required">*</span>
                            </label>
                            <select name="state" value={form.state} onChange={handleChange}>
                                <option value="">Select State</option>
                                {indianStates.map((s) => (
                                    <option key={s.code} value={s.name}>
                                        {s.name}
                                    </option>
                                ))}
                            </select>
                            {/* <input
                                name="state"
                                type="text"
                                value={form.state}
                                onChange={handleChange}
                            /> */}
                        </div>

                        <div className="field">
                            <label>
                                Pincode <span className="required">*</span>
                            </label>
                            <input
                                type="text"
                                name="pincode"
                                placeholder="6-digit pincode"
                                maxLength={6}
                                inputMode="numeric"
                                pattern="[0-9]*"
                                value={form.pincode}
                                onChange={handleChange}
                            />
                        </div>
                    </div>


                    {/* Address Type */}
                    <div className="address-type">
                        {["HOME", "WORK", "OTHER"].map(type => (
                            <label key={type}>
                                <input
                                    type="radio"
                                    name="address_type"
                                    value={type}
                                    checked={form.address_type === type}
                                    onChange={handleChange}
                                />
                                {type}
                            </label>
                        ))}
                    </div>

                    {/* Default */}
                    <div className="default-checkbox">
                        <input
                            type="checkbox"
                            name="is_default"
                            checked={form.is_default}
                            onChange={handleChange}
                        />
                        <span>Make this my default address</span>
                    </div>

                </div>

                {/* Footer */}
                <div className="address-footer">
                    <button className="btn cancel" onClick={onClose}>Cancel</button>
                    <button className="btn save" onClick={handleSubmit}>Save Address</button>
                </div>

            </div>
        </div>
    );
};

export default AddressModal;
